module.exports = __webpack_public_path__ + "static/media/img6.55170f45.jpg";